/**
 * Checks if any given value of x has a value, when it's an array it  checks the length
 * before that checks for null and undefined
 * @param x The subject in which we're chekcing the value
 */
export function hasValue(x: any): boolean {
  const xType = typeof x;

  // null or undefined
  if (x === null || xType === 'undefined') {
    return false;
  }

  // array check
  if (Array.isArray(x)) {
    return x.length !== 0;
  }

  // string check
  if (xType === 'string') {
    return x !== '';
  }

  // object check
  if (xType === 'object') {
    return Object.keys(x).length !== 0;
  }

  return true;
}
